import { render, staticRenderFns } from "./DiEditor.vue?vue&type=template&id=34c79c3c&scoped=true&"
import script from "./DiEditor.vue?vue&type=script&lang=js&"
export * from "./DiEditor.vue?vue&type=script&lang=js&"
import style0 from "./DiEditor.vue?vue&type=style&index=0&id=34c79c3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c79c3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
